"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _theme = require("../theme");
var _system = require("@mui/system");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param isSelected
 * @param onClick
 * @param label
 * @param customStyle
 * @param clickable
 * @returns {*}
 * @constructor
 */
var Bubble = function Bubble(_ref) {
  var isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    label = _ref.label,
    customStyle = _ref.customStyle,
    _ref$clickable = _ref.clickable,
    clickable = _ref$clickable === void 0 ? true : _ref$clickable,
    disabled = _ref.disabled,
    disabledHover = _ref.disabledHover;
  var theme = (0, _system.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
    size: "medium",
    label: label,
    color: disabled ? "default" : "primary",
    clickable: disabled ? false : clickable,
    variant: isSelected ? 'default' : 'outlined',
    sx: _objectSpread({
      cursor: disabled ? "default" : 'pointer',
      padding: "20px",
      margin: "10px 0",
      borderRadius: "20px",
      borderWidth: "2px",
      fontFamily: _theme.fonts.type.heading,
      fontSize: 14,
      color: isSelected ? '#FFF' : '#000',
      minWidth: "170px",
      letterSpacing: '0.01071em',
      '&:hover': {
        backgroundColor: disabledHover ? null : theme.palette.custom.bubbleHover
      }
    }, customStyle),
    onClick: disabled ? null : onClick
  });
};
var _default = exports["default"] = Bubble;